import GoogleButton from '@/next/components/GoogleButton/GoogleButton';

export default GoogleButton;
